import { render, staticRenderFns } from "./AgencyManage.vue?vue&type=template&id=0ccf39ce&scoped=true&"
import script from "./AgencyManage.vue?vue&type=script&lang=js&"
export * from "./AgencyManage.vue?vue&type=script&lang=js&"
import style0 from "./AgencyManage.vue?vue&type=style&index=0&id=0ccf39ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf39ce",
  null
  
)

export default component.exports